import { forwardRef } from 'react';
import {
  DocumentFolderNode,
  isDocument,
} from 'helpers/documents/types/documents';
import { DocumentListItem } from './DocumentListItem.tsx';
import { FolderListItem } from './FolderListItem.tsx';
import { DocumentTreeItemProps } from './shared/types.ts';

export const DocumentTreeItem = forwardRef<
  HTMLDivElement,
  DocumentTreeItemProps
>((props, ref) =>
  isDocument(props.item) ? (
    <DocumentListItem {...props} item={props.item} ref={ref} />
  ) : (
    <FolderListItem
      {...props}
      item={props.item as typeof props.item & DocumentFolderNode}
      ref={ref}
    />
  ),
);
